/**
 * Created by zhangkaili on 20178/1/8.
 */

import {request} from '../http';
import domain from '../domain';
import {getCookie} from '../util/cookie';

var SearchService = function(){
    if(domain.env === 'online'){
        this.domain = '//search.51tiangou.com';
    }else{
        this.domain = "//search." + domain.env + ".66buy.com.cn";
    }
};

SearchService.prototype._serviceAjaxCom = function(url,params){
	params.url = this.domain + url;
	return request(params);
};

// 搜索中间页查找热门搜索词
SearchService.prototype.getHotWord = function(params){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/front/searchWord/hotWordList", params);
};

export default new SearchService();